import type { CardData } from '@shared/types';

export function canSpeak(): boolean {
  return typeof window !== 'undefined' && 'speechSynthesis' in window;
}

function pickVoice(lang: string): SpeechSynthesisVoice | undefined {
  const voices = window.speechSynthesis.getVoices();
  return voices.find((v) => v.lang === lang) ?? voices.find((v) => v.lang.startsWith(lang.slice(0, 2)));
}

/**
 * Read a card out loud. Hindi lines use the Devanagari text with a Hindi voice when the device
 * has one; everything else uses an Indian English voice. Blanks are read as "blank".
 */
export function speakCard(card: Pick<CardData, 'text' | 'devanagari'>, answers?: string[]): void {
  if (!canSpeak()) return;
  const synth = window.speechSynthesis;
  synth.cancel();
  const useHindi = Boolean(card.devanagari && !answers?.length && pickVoice('hi-IN'));
  let line = useHindi ? card.devanagari! : card.text;
  let i = 0;
  line = line.replace(/_{3}/g, () => answers?.[answers.length === 1 ? 0 : i++] ?? (useHindi ? 'खाली' : 'blank'));
  const utterance = new SpeechSynthesisUtterance(line);
  utterance.lang = useHindi ? 'hi-IN' : 'en-IN';
  const voice = pickVoice(utterance.lang);
  if (voice) utterance.voice = voice;
  utterance.rate = 0.95;
  synth.speak(utterance);
}
